import { G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Two_Way_2: React.FC<Props> = ({ fill }) => {
    return (
        <Svg id="Capa_1" fill={fill} x="0px" y="0px" width="12pt" height="100%" viewBox="0 0 97.9 97.9">
            <G>
                <Path d="M41.968,15.961c-0.692-0.334-1.514-0.241-2.115,0.238l-39.1,31.177C0.278,47.756,0,48.331,0,48.94 c0,0.608,0.277,1.184,0.753,1.563l39.1,31.19c0.361,0.287,0.802,0.437,1.248,0.437c0.295,0,0.591-0.065,0.867-0.198 C42.66,81.6,43.1,80.898,43.1,80.13V17.763C43.1,16.995,42.66,16.294,41.968,15.961z" />
                <Path d="M97.146,47.377l-39.1-31.188c-0.601-0.479-1.423-0.573-2.115-0.238c-0.691,0.333-1.131,1.034-1.131,1.802v62.396 c0,0.769,0.439,1.469,1.133,1.801c0.275,0.134,0.572,0.199,0.867,0.199c0.444,0,0.887-0.148,1.248-0.438l39.1-31.206 c0.476-0.379,0.752-0.955,0.752-1.563C97.9,48.331,97.623,47.756,97.146,47.377z" />
            </G>
        </Svg>
    );
};
export default Two_Way_2;
